
import { AjaxFormValidation } from '@common/libs/ajax-form-validation';
import { Layout } from '../libs/layout';

export { Comments };

let Comments = {
    $form: null,
    $replyToAlert: null,
    $successAlert: null,
    $dangerAlert: null,
    $wrapper: $('#commentPost'),
    page: 1, // For loading more comments

    init() {
        this.$form = this.$wrapper.find('form.CommentAdd');
        this.$replyToAlert = this.$wrapper.find('.alert-reply');
        this.$successAlert = this.$wrapper.find('.alert-success');
        this.$dangerAlert = this.$wrapper.find('.alert-danger');

        this.initReplyToEvents();
        this.initShowMoreComments();
    },

    /**
     * Bind form validation
     */
    initFormValidation(callbacks) {
        callbacks = $.extend({
            error: (response) => {}, // {function}
            success: (response) => {} // {function}
        }, callbacks);

        let self = this;
        let $form = $('form.CommentAdd:not(.validation-applied)');
        let commentValidator = new AjaxFormValidation($form, '/comments/ajax_validate', 'basic');
    
        $form.addClass('validation-applied');

        let validateInput = function(elem) {
            // Client side validation ok, do not do server side            
            if ($(elem).hasClass('is-valid')) {
                return;
            }
            commentValidator.validate(elem, {}, {
                // Disable button while server validation is in-progress
                beforeSend: function() {
                    $form.find('[type="submit"]').attr('disabled', true);
                }
            }).always(function(response) {
                $form.find('[type="submit"]').removeAttr('disabled');
            });
        };

        $form.on('blur', '.CommentContent, .CommentName, .CommentEmail', function(e) {
            validateInput(this);
        })
        // Form submission
        .on('click', '[type="submit"]', (e) => {
            e.preventDefault();
            if (!commentValidator.valid()) {
               return false;
            }

            let $btn = $(e.currentTarget), $btnSubmitting = $form.find('.btn-submitting');

            $btn.hide();
            $btnSubmitting.show();

            $.ajax({
                type: 'POST',
                url: $form.attr('action'),
                data: $form.serialize(),
                dataType: 'json'
            }).done(function(response) {
                $btn.show();
                $btnSubmitting.hide();

                // Submitted
                if (response.message) {
                    self.addSuccessMessage(response.message);
                    commentValidator.reset();
                    self.resetReplyToAlert();

                    callbacks.success.call(this, response);
                    return;
                }

                // Unable to submit the comment 
                if (response.error) {
                    self.addErrorMessage(response.error);
                    callbacks.error.call(this, response);
                    return;
                }

                // Validation errors
                if (response.errors) {
                    let errors = response.errors, field, i, formField, error;
                    for (field in errors) {
                        formField = 'data[Comment]['+field+']', error = {};
                        if (typeof errors[field] === 'string') {
                            error[formField] = errors[field];
                            commentValidator.getValidator().showErrors(error);
                        } else {
                            for (i in errors[field]) {
                                error[formField] = errors[field][i];
                                commentValidator.getValidator().showErrors(error);
                            }
                        }
                    }
                    callbacks.error.call(this, response);
                    return;
                }
            });

        });
    },

    /**
     * Reply to events
     */
    initReplyToEvents() {
        this.$wrapper.on('click', '.reply-to', (e) => {
            e.preventDefault();
            let $this = $(e.currentTarget), 
                $comemntTextarea = this.$form.find('.CommentContent'),
                replyToId = $this.data('reply-to-id'),
                replyToName = $this.data('reply-to-name');

            Layout.slideToElement(this.$wrapper);

            this.$replyToAlert.show();
            this.$replyToAlert.find('.alert-link').html(replyToName).attr('href', `#comment-${replyToId}`);
            this.$form.find('[name="data[Comment][reply_to]"]').val(replyToId);

            if (!$comemntTextarea.data('orig-placeholder')) {
                $comemntTextarea.data('orig-placeholder', $comemntTextarea.attr('placeholder'));
            }

            $comemntTextarea.attr('placeholder', 'Reply to a comment');
        });

        // Close reply alert
        this.$wrapper.on('click', '.close-inreply', (e) => {
            let $alert = $(e.currentTarget).closest('.alert'),
                $comemntTextarea = this.$form.find('.commentTextarea');

            this.resetReplyToAlert();
            $comemntTextarea.attr('placeholder', $comemntTextarea.data('orig-placeholder'));
            this.$form.find('[name="data[Comment][reply_to]"]').val('');
        });

        // Scroll back to the specific user comment
        this.$wrapper.on('click', '.alert-link', (e) => {
            e.preventDefault();
            Layout.slideToElement($($(e.currentTarget).attr('href')));
        });
    },

    /**
     * Display more comments
     */
    initShowMoreComments() {
        this.$wrapper.on('click', '.displayComments', (e) => {
            e.preventDefault();

            let $element = $(e.currentTarget), 
                $parent = $element.parent(), 
                $spinner = $parent.find('.spinner-border'),
                url = '/comments/load_more_comments',
                nodeId = $element.data('node-id'),
                limit = $element.data('limit'),
                originalHtmlTitle = $element.html(),
                version = 5;

            $spinner.show();
            $element.attr('disabled', true).html('<strong>Loading more comments...</strong>');
            ++this.page;

            $.ajax({
                type: 'GET',
                url: `${url}/${nodeId}/${this.page}/${limit}/${version}`,
                dataType: 'json'
            }).done((response) => {
                if (this.page >= response.pageCount) {
                    $parent.remove();
                } else {
                    $element.removeAttr('disabled').html(originalHtmlTitle);
                }

                $spinner.hide();
                Layout.slideToElement($('.comment-list ul li:last-child'));
                $('.comment-list ul:first-child').append(response.commentsAsHtml);
            });
        });
    },

    resetReplyToAlert() {
        this.$replyToAlert.hide();
        this.$replyToAlert.find('.alert-link').html('');
    },

    addSuccessMessage(message) {
        this.$wrapper.find('.alert-success').html(message).show();
        this.$wrapper.find('.alert-danger').html('').hide();
    },

    addErrorMessage(message) {
        this.$wrapper.find('.alert-danger').html(message).show(); 
        this.$wrapper.find('.alert-success').html('').hide();
    }


}